import { useEffect, useState } from 'react';
import { VisibilityType } from '../types/VisibilityType';

type SetActiveMenuType = (menu: string) => void;

const createInitialVisibility = (): VisibilityType => {
    return {
        activeMenu: '',
        callbackOpenVisible: true,
        callClosedVisible: false,
        callOpenVisible: true,
        hidePanelReasons: [],
    };
};

export const useVisibility = (): [VisibilityType, SetActiveMenuType] => {
    const [visibility, setVisibility] = useState(createInitialVisibility);

    useEffect(() => {
        addVisibilityListeners();

        return () => {
            removeVisibilityListeners();
        };
    }, []);

    const VisibilityListeners = {
        setActiveMenu: (e: CustomEvent) => setActiveMenu(e.detail),
        setCallbackOpenVisible: (e: CustomEvent) => setCallbackOpenVisible(e.detail),
        setCallClosedVisible: (e: CustomEvent) => setCallClosedVisible(e.detail),
        setCallOpenVisible: (e: CustomEvent) => setCallOpenVisible(e.detail),
        addHidePanelReason: (e: CustomEvent) => addHidePanelReason(e.detail),
        removeHidePanelReason: (e: CustomEvent) => removeHidePanelReason(e.detail),
    };

    const addVisibilityListeners = () => {
        for (const key of Object.keys(VisibilityListeners)) {
            (window as any).addEventListener(key, VisibilityListeners[key]);
        }
    };

    const removeVisibilityListeners = () => {
        for (const key of Object.keys(VisibilityListeners)) {
            (window as any).removeEventListener(key, VisibilityListeners[key]);
        }
    };

    const setCallbackOpenVisible = (visible: boolean) =>
        setVisibility((previous) => ({ ...previous, callbackOpenVisible: visible }));

    const setActiveMenu = (menu: string) =>
        setVisibility((previous) => ({ ...previous, activeMenu: menu }));

    const setCallOpenVisible = (visible: boolean) =>
        setVisibility((previous) => ({ ...previous, callOpenVisible: visible }));

    const setCallClosedVisible = (visible: boolean) =>
        setVisibility((previous) => ({ ...previous, callClosedVisible: visible }));

    const addHidePanelReason = (reason: string) =>
        setVisibility((previous) =>
            previous?.hidePanelReasons?.includes(reason) === true
                ? previous
                : { ...previous, hidePanelReasons: [...previous.hidePanelReasons, reason] }
        );

    const removeHidePanelReason = (reason: string) =>
        setVisibility((previous) =>
            previous?.hidePanelReasons?.includes(reason) === true
                ? {
                      ...previous,
                      hidePanelReasons: previous.hidePanelReasons.filter((r) => r !== reason),
                  }
                : previous
        );

    return [visibility, setActiveMenu];
};
